import TextField, { FilledTextFieldProps } from "@material-ui/core/TextField";
import { Field, FieldProps } from "formik";
import React from "react";

import { fixAmount } from "../core/utils";

interface IProps extends Partial<FilledTextFieldProps> {
  label: string;
  name: string;
  type?: string;
  validate?: (value: string) => any;
}

export const TextInput: React.FC<IProps> = ({ label, name, type, onChange, onBlur, validate, ...rest }: IProps) => {
  const isAmount = type === "number";

  return (
    <Field name={name} validate={validate}>
      {({ field, form: { setFieldValue }, meta }: FieldProps): JSX.Element => {
        return (
          <TextField
            name={name}
            type={type}
            label={label}
            fullWidth
            variant="filled"
            margin="normal"
            error={Boolean(meta.touched && meta.error)}
            helperText={meta.touched && meta.error}
            value={meta.value}
            // onFocus={() => {
            // if (isAmount && meta.value === 0) {
            //   setFieldValue(name, "");
            // }
            // }}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange(e);
            }}
            onBlur={(e) => {
              field.onBlur(e);

              if (isAmount) {
                setFieldValue(name, fixAmount(meta.value).toString());
              }

              onBlur && onBlur(e);
            }}
            {...rest}
          />
        );
      }}
    </Field>
  );
};
